import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the OperadorInfoprodutoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-operador-infoproduto',
  templateUrl: 'operador-infoproduto.html',
})
export class OperadorInfoprodutoPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OperadorInfoprodutoPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/operador-infoproduto/operador-infoproduto.ts